export const getBase64 = file => {
    return new Promise(resolve => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            let index = reader.result.indexOf(",");
            let strResult = reader.result.substr(index+1);
            // baseURL = reader.result;
            resolve(strResult);
        };
    });
};